import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import {
  Company,
  CompanyCreateParams,
  CompanyFindAllParams,
} from '../core/type';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { CompanyService } from '../core/service';

@Injectable()
export class CompanyApiService implements CompanyService {
  private readonly defaultUrl = `${environment.apiHost}/companys`;

  constructor(private httpClient: HttpClient) {}

  update(id: number, data: Omit<Company, 'id'>): Observable<void> {
    let formData: FormData = new FormData();

    Object.keys(data).forEach((key) => {
      formData.append(key, (data as any)[key]);
    });

    return this.httpClient.patch<void>(`${this.defaultUrl}/${id}`, formData);
  }

  getById(id: number): Observable<Company> {
    return this.httpClient.get<Company>(`${this.defaultUrl}/${id}`);
  }

  findAll(
    filter?: CompanyFindAllParams | undefined
  ): Observable<PaginatedResponse<Company>> {
    return this.httpClient.get<PaginatedResponse<Company>>(this.defaultUrl, {
      params: { ...filter },
    });
  }

  create(data: Omit<CompanyCreateParams, 'id'>) {
    let formData: FormData = new FormData();

    Object.keys(data).forEach((key) => {
      formData.append(key, (data as any)[key]);
    });

    return this.httpClient.post<void>(this.defaultUrl, formData);
  }

  delete(id: number): Observable<void> {
    throw new Error('Method not implemented.');
  }

  getFileBuffer(filename: string): Observable<Blob> {
    return this.httpClient.get<Blob>(`${this.defaultUrl}/file/${filename}`, {
      responseType: 'blob' as 'json',
    });
  }
}
